var BatchAPI = require('./gen/batch_api');

module.exports = BatchAPI;
